import { render, staticRenderFns } from "./useDetail.vue?vue&type=template&id=2a5f2db6&scoped=true&"
import script from "./useDetail.vue?vue&type=script&lang=js&"
export * from "./useDetail.vue?vue&type=script&lang=js&"
import style0 from "./useDetail.vue?vue&type=style&index=0&id=2a5f2db6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f2db6",
  null
  
)

export default component.exports